import { AisOrder, Result, LabeledObject, Params, ResearchSheet } from 'types';
import fetch from 'utils/fetch';
import { useCachedFetch } from 'utils/use-cached-fetch';

/**
 * Function for making new order.
 */
export async function postNewOrder(values: object) {
  try {
    const response = await fetch(`/api/order`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(values),
    });

    const newOrder: AisOrder = await response.json();

    return newOrder;
  } catch (e) {
    console.log(e);
    return undefined;
  }
}

/**
 * Function for rework of existing order.
 */
export async function putReworkOrder(order: AisOrder): Promise<boolean> {
  const response = await fetch(`/api/order/${order?.id}/rework`, {
    method: 'PUT',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(order),
  });

  return response.ok;
}

/**
 * Function for fetching 'my-orders' history.
 */
export async function fetchMyOrders(params: Params): Promise<Result<AisOrder>> {
  const response = await fetch(`/api/order/my-orders`, {
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(params),
  });
  const json = await response.json();

  return json;
}

export async function getResearchSheetTopic(researchSheetId: string) {
  const response = await fetch(`/api/research-sheet/${researchSheetId}`);

  const json: ResearchSheet = await response.json();

  return json.researchTopic;
}

/**
 * Enum hook for fetching order states.
 */
export function useOrderStates() {
  return useCachedFetch<LabeledObject[]>('/api/order/states') || [];
}

export async function acknowledgeOrder(id: string) {
  try {
    await fetch(`/api/order/${id}/acknowledge`, {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
    });

    return {
      ok: true,
      data: {},
    };
  } catch (err) {
    return {
      ok: false,
      data: err,
    };
  }
}
